import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './AppRouter';
import { AuthProvider } from './context/AuthContext';
import { TenantConfigProvider } from './context/TenantConfigContext';
import './styles/tokens.css';

import { ConfirmProvider } from './components/ui/ConfirmDialog';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfirmProvider>
      <AuthProvider>
        <TenantConfigProvider>
          <AppRouter />
        </TenantConfigProvider>
      </AuthProvider>
    </ConfirmProvider>
  </React.StrictMode>
);
